import { Button } from '@bfe/moly';
import { AntiPhishingCodeIcon } from '@bfe/moly-icons';
import { useEffect } from 'react';

import AccountBasicItem from '@/components/AccountBasicItem';
import { SecuritySettingModalNames } from '@/components/SecuritySettingModalManager';
import { useI18nContext } from '@/i18n/I18n';
import { useSecuritySettingModal } from '@/store/useSecuritySettingModal/useSecuritySettingModal';
import { useSecuritySettingModalData } from '@/store/useSecuritySettingModal/useSecuritySettingModalData';
import { useStore } from '@/store/useStore';

const AntiPhishingCodeItem = () => {
  const [$t] = useI18nContext();
  const { userInfo: user } = useStore();
  const { getAntiPhishing, hasAntiPhishing, antiPhishingCode } =
    useSecuritySettingModalData();
  const { openSecuritySettingModal } = useSecuritySettingModal();

  useEffect(() => {
    user?.id && getAntiPhishing();
  }, [user]);

  const openSetAntiPhishingModal = () => {
    openSecuritySettingModal(SecuritySettingModalNames.AntiPhishingModal);
  };

  return (
    <>
      <AccountBasicItem
        icon="anti phishing code"
        molyIcon={<AntiPhishingCodeIcon />}
        text={$t('AntiPhishingCode')}
        subText={$t('AntiPhishingCodeDesc')}
        status={hasAntiPhishing}
        statusNode={
          <>
            {hasAntiPhishing ? (
              <span>{antiPhishingCode}</span>
            ) : (
              <span className="not-set-text">{$t('Not Set')}</span>
            )}
          </>
        }
        operation={
          <>
            {hasAntiPhishing && (
              <Button
                size="small"
                data-radius="small"
                variant="secondary"
                onClick={openSetAntiPhishingModal}
              >
                {$t('modify')}
              </Button>
            )}

            {!hasAntiPhishing && (
              <Button
                size="small"
                data-radius="small"
                variant="primary"
                onClick={openSetAntiPhishingModal}
              >
                {$t('Setting')}
              </Button>
            )}
          </>
        }
      />
    </>
  );
};
export default AntiPhishingCodeItem;
